module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-Light-0dd62cbd9bd9203f15288dc9b166189d.woff2";